export default __webpack_public_path__ + "static/jardin2-24e79591825468db863b901f81d868cb.png";